var exports = {
  "K2": "PricingGrid.module__gridWrapper___d2FSUm",
  "Vg": "PricingGrid.module__grid___d2FSUm",
  "mS": "PricingGrid.module__gridTwoColumns___d2FSUm" + " " + "PricingGrid.module__grid___d2FSUm",
};

module.exports = exports;
